import ApiError from './errors/ApiError';
import JsonError from './errors/JsonError';

export default (apiRes: Response) => {
  return new Promise((res, rej) => {
    apiRes
      .json()
      .then(apiResJson => {
        if (apiRes.ok) {
          res(apiResJson);
        } else {
          rej(
            new ApiError({
              status: apiRes.status,
              message: apiRes.statusText,
              error: apiResJson,
            })
          );
        }
      })
      .catch(() => {
        rej(new JsonError());
      });
  });
};
